import { Col, Radio, Row, Tooltip } from 'antd';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { convertToFloat, getStyleVariableValue } from '../../../../../../../utilz';
import { routeFileSelector } from '../../../../../../../utilz/i18n';
import FilterCard from '../../../../../../components/Cards/FilterCard';
import FormLabel from '../../../../../../components/Labels/FormLabel';
import HighlightLabel from '../../../../../../components/Labels/HighlightLabel';
import SecondaryLabel from '../../../../../../components/Labels/SecondaryLabel';
import TooltipTable from '../../../../../../components/Tables/TooltipTable';

const RateShopDetailsCard = ({ rateDetails, checked, onSelect }) => {
  const { pathname: activeTab } = useLocation();
  const namespace = useMemo(() => routeFileSelector(activeTab), [activeTab]);
  const { t } = useTranslation([namespace, 'translation']);
  const getTooltipContent = () => {
    return (
      <TooltipTable>
        <tr>
          <th>{t('translation:default.fields.costName')}</th>
          <th>{t('translation:default.fields.cost')}</th>
        </tr>
        {rateDetails.accessorials?.map(({ description, auditedChargeAmount, currencyCode }, key) => (
          // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
          <tr key={key}>
            <td>{description}</td>
            <td>
              {auditedChargeAmount} <span className="f-10 fw-300 text-light">{currencyCode}</span>
            </td>
          </tr>
        ))}
      </TooltipTable>
    );
  };
  return (
    <FilterCard
      className="mb-15"
      shadow={false}
      showBorder
      customHeader={
        <div className="w-100">
          <Row>
            <Col>
              <Radio className="form-radio-group-container" checked={checked} onChange={onSelect}>
                <span className="pointer-events-none">
                  {/* biome-ignore lint/a11y/noLabelWithoutControl: <explanation> */}
                  <label className="f-12 fw-400">
                    {t('translation:default.fields.transportationProvider.label')} :{' '}
                  </label>
                  {/* biome-ignore lint/a11y/noLabelWithoutControl: <explanation> */}
                  <label className="f-12 fw-600">{rateDetails.carrierName}</label>
                </span>
              </Radio>
            </Col>
          </Row>
        </div>
      }
    >
      <div className="p-15">
        <Row gutter={30}>
          <Col sm={6}>
            <Tooltip
              color={getStyleVariableValue('--label')}
              title={getTooltipContent()}
              placement="bottomLeft"
              overlayClassName="mw-none rate-shop-cost-tool-tip"
            >
              <FormLabel>{t('translation:getQuote.rateShopDetails.convertedCost')}</FormLabel>
              <br />
              {/* biome-ignore lint/a11y/noLabelWithoutControl: <explanation> */}
              <label className="f-12">
                <HighlightLabel className="f-14 fw-600">{convertToFloat(rateDetails.convertedCost, 2)}</HighlightLabel>
              </label>
            </Tooltip>
          </Col>
          <Col sm={6}>
            <FormLabel>{t('translation:getQuote.rateShopDetails.convertedCurrencyCode')}</FormLabel>
            <br />
            <SecondaryLabel className="f-12 f-14 fw-600 text-dark">{rateDetails.convertedCurrencyCode}</SecondaryLabel>
          </Col>
          <Col sm={6}>
            <FormLabel>{t('translation:getQuote.rateShopDetails.standardTransitDays')}</FormLabel>
            <br />
            <SecondaryLabel className="f-12 f-14 fw-600 text-dark">{rateDetails.standardDaysTransit}</SecondaryLabel>
          </Col>
          <Col sm={6}>
            <FormLabel>{t('translation:default.fields.cargoType.label')}</FormLabel>
            <br />
            <SecondaryLabel className="f-12 f-14 fw-600 text-dark">{rateDetails.cargoType}</SecondaryLabel>
          </Col>
        </Row>
      </div>
    </FilterCard>
  );
};

export default RateShopDetailsCard;
